import React from 'react';
export const NON_DEFAULT_BADGE_SKINS = [
    'error',
    'success',
    'warning',
    'primary',
    'branded'
];
export const skinToTypographyMap = {
    default: 'secondary',
    error: 'error',
    success: 'success',
    warning: 'warning',
    primary: 'primary',
    branded: 'secondary'
};
export const sizeToTypographyVariantMap = {
    default: 'paragraph2',
    big: 'paragraph2',
    small: 'paragraph3'
};
